var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33346 2.66667L7.00012 2L6.66679 2.66667L6.00012 2.75L6.55612 3.222L6.33346 4L7.00012 3.556L7.66679 4L7.44412 3.222L8.00012 2.75L7.33346 2.66667ZM12.8895 9.77733L12.3335 8.66667L11.7775 9.77733L10.6668 9.91667L11.5928 10.704L11.2228 12L12.3335 11.2593L13.4441 12L13.0741 10.704L14.0001 9.91667L12.8895 9.77733ZM4.44479 4.222L4.00012 3.33333L3.55546 4.222L2.66679 4.33333L3.40746 4.96267L3.11146 6L4.00012 5.40733L4.88879 6L4.59279 4.96267L5.33346 4.33333L4.44479 4.222ZM2.27612 11.3333C2.27612 11.6893 2.41479 12.024 2.66679 12.276L3.72412 13.3333C3.97612 13.5853 4.31079 13.724 4.66679 13.724C5.02279 13.724 5.35746 13.5853 5.60946 13.3333L13.3335 5.60933C13.5855 5.35733 13.7241 5.02267 13.7241 4.66667C13.7241 4.31067 13.5855 3.976 13.3335 3.724L12.2761 2.66667C11.7721 2.16267 10.8948 2.16267 10.3908 2.66667L2.66679 10.3907C2.41479 10.6427 2.27612 10.9773 2.27612 11.3333ZM11.3335 3.60933L12.3908 4.66667L10.0001 7.05733L8.94279 6L11.3335 3.60933Z",
    fill: "currentColor",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.4717322f7d7a97eb363952a3a273c314.svg";
export { ForwardRef as ReactComponent };